module.exports = __webpack_public_path__ + "static/img/zichan_01.3884f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zichan_01.png
// module id = zJ84
// module chunks = 1